import { render, staticRenderFns } from "./RichiediConfermaModal.vue?vue&type=template&id=19c0f725&"
import script from "./RichiediConfermaModal.vue?vue&type=script&lang=js&"
export * from "./RichiediConfermaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RichiediConfermaModal.vue"
export default component.exports